define('SageDotCom/Components/ProductCard/ProductBuyButton',[
    "jquery",
    "score_bootstrap/Components/Button", 
    "SageDotCom/DataLayer/Events/product-card-detail"
], function ($, button, ProductCardDetailEvent) {

    return function (args) {
        button.init(args);
        
        // Track click on Buy button
        $(args.scope).on("click", "a", function (e) {
            const originalUrl = $(this).attr("href");
            const productService = new ProductCardDetailEvent();

            if (originalUrl) {
                if (originalUrl.indexOf("sku=") > -1 || originalUrl.indexOf("client-management") > -1) {
                    var entryMethod = $(this).parents(".modal").get(0) ? "Popup" : "Product Card";
                    productService.triggerAddToCartTealiumEvent(originalUrl, $(this), entryMethod);
                } else if (originalUrl.indexOf("es") > -1) {
                    const product = getProductData.call(this);
                       productService.addToCartTealiumOld(product, originalUrl, $(this));
                }
            }
        });
    };

    function getProductData() {
        // Get base product data from product card container, 
        // later we can augment it with additional properties taken from other components placed in the product card container
        const product = $(this).closest("[id^=productcardcontainer]").data("dataUxArgs").Product;
        return product ? JSON.parse(product) : null;
    }
});
